var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenLinkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6 20.6301H8.39998C7.88664 20.6301 7.46664 20.2101 7.46664 19.6968V8.4968C7.46664 7.98347 7.88664 7.56347 8.39998 7.56347H13.0666C13.58 7.56347 14 7.14347 14 6.63013C14 6.1168 13.58 5.6968 13.0666 5.6968H7.46664C6.43064 5.6968 5.59998 6.5368 5.59998 7.56347V20.6301C5.59998 21.6568 6.43998 22.4968 7.46664 22.4968H20.5333C21.56 22.4968 22.4 21.6568 22.4 20.6301V15.0301C22.4 14.5168 21.98 14.0968 21.4666 14.0968C20.9533 14.0968 20.5333 14.5168 20.5333 15.0301V19.6968C20.5333 20.2101 20.1133 20.6301 19.6 20.6301ZM15.8666 6.63013C15.8666 7.14347 16.2866 7.56347 16.8 7.56347H19.2173L10.696 16.0848C10.332 16.4488 10.332 17.0368 10.696 17.4008C11.06 17.7648 11.648 17.7648 12.012 17.4008L20.5333 8.87947V11.2968C20.5333 11.8101 20.9533 12.2301 21.4666 12.2301C21.98 12.2301 22.4 11.8101 22.4 11.2968V5.6968H16.8C16.2866 5.6968 15.8666 6.1168 15.8666 6.63013Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLinkWhite);
export default __webpack_public_path__ + "static/media/open_link_white.c14fa499fe79fcd22ad5f7b236452594.svg";
export { ForwardRef as ReactComponent };